// @flow
'use strict';

import { connect } from 'react-redux';

import { abreModal } from '../../../../../reducers/modal_exportacao_lote';

import BotaoExportacaoLoteCfe from './botao_exportacao_lote_cfe';

const mapDispatchToProps = {
  abreModalPdf: () => abreModal('pdf', 'cfe'),
  abreModalXml: () => abreModal('xml', 'cfe'),
}

export default connect<*, *, *, *, *, *>(null, mapDispatchToProps)(BotaoExportacaoLoteCfe);
